import { GET_COMPANIES_BY_MODE } from 'actions/downloadAdvanceReport';

const initialState = {
  isLoading: false,
  companiesByMode: [],
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
};
const companiesByModeReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_COMPANIES_BY_MODE.REQUEST: {
      return { ...state, isLoading: true };
    }

    case GET_COMPANIES_BY_MODE.SUCCESS: {
      // Handle both response structures: payload.results or payload directly
      const companiesData = payload?.results || payload || [];
      return {
        ...state,
        isLoading: false,
        companiesByMode: Array.isArray(companiesData) ? companiesData : [],
        page: payload?.page || 1,
        limit: payload?.limit || 10,
        totalPages: payload?.totalPages || 1,
        total: payload?.totalResults || payload?.total || companiesData.length,
      };
    }

    case GET_COMPANIES_BY_MODE.FAIL: {
      return { ...state, isLoading: false };
    }

    default:
      return { ...state };
  }
};

export default companiesByModeReducer;
